import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", null, "删除", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_popconfirm = _resolveComponent("a-popconfirm");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell");
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row");
  const _component_a_table_summary = _resolveComponent("a-table-summary");
  const _component_a_table = _resolveComponent("a-table");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[22] || (_cache[22] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "Customer"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "客户代码",
                  rules: [{
                    required: true,
                    message: '请输入客户代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fCustNumber,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.fCustNumber = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo",
                  label: "Invoice to",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model.customerInvoiceTo = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo1",
                  label: "Street"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo1,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.DMConfig.Model.customerInvoiceTo1 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo2",
                  label: "ZIP Codes"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo2,
                    "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.DMConfig.Model.customerInvoiceTo2 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo3",
                  label: "Country"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo3,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.DMConfig.Model.customerInvoiceTo3 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToContact",
                  label: "Contact",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToContact,
                    "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.DMConfig.Model.customerInvoiceToContact = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToPhone",
                  label: "Phone"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToPhone,
                    "onUpdate:value": _cache[6] || (_cache[6] = $event => $setup.DMConfig.Model.customerInvoiceToPhone = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToFax",
                  label: "Fax"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToFax,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => $setup.DMConfig.Model.customerInvoiceToFax = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToEmail",
                  label: "Email",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToEmail,
                    "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.DMConfig.Model.customerInvoiceToEmail = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "termsOfSale",
                  label: "Terms of Sale",
                  rules: [{
                    required: true,
                    message: 'Terms of Sale is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: $setup.DMConfig.Model.termsOfSale,
                    "onUpdate:value": _cache[9] || (_cache[9] = $event => $setup.DMConfig.Model.termsOfSale = $event),
                    options: $setup.DMConfig.TermsOfSaleList,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "options"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "methodAndTermsOfPayment",
                  label: "Method and Terms of Payment",
                  rules: [{
                    required: true,
                    message: 'Method and Terms of Payment is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: $setup.DMConfig.Model.methodAndTermsOfPayment,
                    "onUpdate:value": _cache[10] || (_cache[10] = $event => $setup.DMConfig.Model.methodAndTermsOfPayment = $event),
                    options: $setup.DMConfig.SettleList,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "options"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "finalDestination",
                  label: "Final Destination",
                  rules: [{
                    required: true,
                    message: 'Method and Terms of Payment is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.finalDestination,
                    "onUpdate:value": _cache[11] || (_cache[11] = $event => $setup.DMConfig.Model.finalDestination = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "termsOfSale",
                  label: "Port of Loading",
                  rules: [{
                    required: true,
                    message: 'Port of Loading is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: $setup.DMConfig.Model.portOfLoading,
                    "onUpdate:value": _cache[12] || (_cache[12] = $event => $setup.DMConfig.Model.portOfLoading = $event),
                    options: $setup.DMConfig.PortOfLoadingList,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "options"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "2",
            tab: "Deliver To"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_table, {
              size: "small",
              tableLayout: _ctx.fixed,
              bordered: "",
              columns: $setup.DMConfig.Columns,
              dataSource: $setup.DMConfig.Model['deliverToList'],
              scroll: {
                x: 'calc(100%)'
              },
              pagination: false,
              rowKey: "FEntryId"
            }, {
              bodyCell: _withCtx(({
                column,
                record,
                index,
                text
              }) => [column.dataIndex === 'operation' ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                key: 0,
                placement: "topRight",
                title: "确认删除？",
                onConfirm: () => $setup.delRow(record)
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 2
              }, 1032, ["onConfirm"])) : (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                name: ['deliverToList', index, column.dataIndex],
                rules: column.rules
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: record[column.dataIndex],
                  "onUpdate:value": $event => record[column.dataIndex] = $event,
                  allowClear: true
                }, null, 8, ["value", "onUpdate:value"])]),
                _: 2
              }, 1032, ["name", "rules"]))]),
              summary: _withCtx(() => [_createVNode(_component_a_table_summary, {
                fixed: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_a_table_summary_row, null, {
                  default: _withCtx(() => [_createVNode(_component_a_table_summary_cell, {
                    "col-span": 5,
                    style: {
                      "text-align": "right"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_button, {
                      size: "small",
                      onClick: $setup.addRow
                    }, {
                      default: _withCtx(() => [_createTextVNode("Add Row")]),
                      _: 1
                    }, 8, ["onClick"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["tableLayout", "columns", "dataSource", "scroll"])]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "3",
            tab: "Notify Party"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyParty",
                label: "Notify Party"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.notifyParty,
                  "onUpdate:value": _cache[13] || (_cache[13] = $event => $setup.DMConfig.Model.notifyParty = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyParty1",
                label: "Address Line 1"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.notifyParty1,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => $setup.DMConfig.Model.notifyParty1 = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyParty2",
                label: "Address Line 2"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.notifyParty2,
                  "onUpdate:value": _cache[15] || (_cache[15] = $event => $setup.DMConfig.Model.notifyParty2 = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyParty3",
                label: "Contact (Phone/Email)"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.notifyParty3,
                  "onUpdate:value": _cache[16] || (_cache[16] = $event => $setup.DMConfig.Model.notifyParty3 = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "4",
            tab: "Freight Forwarder"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "freightForwarder",
                label: "Freight Forwarder "
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.freightForwarder,
                  "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.DMConfig.Model.freightForwarder = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "freightForwarder1",
                label: "Address Line 1"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.freightForwarder1,
                  "onUpdate:value": _cache[18] || (_cache[18] = $event => $setup.DMConfig.Model.freightForwarder1 = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "freightForwarder2",
                label: "Address Line 2"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.freightForwarder2,
                  "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.DMConfig.Model.freightForwarder2 = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "freightForwarderContact",
                label: "Contact"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.freightForwarderContact,
                  "onUpdate:value": _cache[20] || (_cache[20] = $event => $setup.DMConfig.Model.freightForwarderContact = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              md: 20,
              sm: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "freightForwarderPhone",
                label: "Phone"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "",
                  value: $setup.DMConfig.Model.freightForwarderPhone,
                  "onUpdate:value": _cache[21] || (_cache[21] = $event => $setup.DMConfig.Model.freightForwarderPhone = $event),
                  allowClear: "true"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "onOk"]);
}